//homeStore.js
import { observable, action } from "mobx"
import moment from "moment"
const end = moment().subtract(1, "days")
const start = moment().subtract(180, "days")
class AppStore {
  @observable date = end

  @action setDate(v: any) {
    this.date = v
  }

  disabledDate(date) {
    if (date > end || date < start) {
      return true
    }
    return false
  }
}
export default new AppStore()
